import type { Valuation } from '../../hooks/valuationFragment';
import { ViewEditNarrativeFuturePEMultipleCalculator } from './ViewEditNarrativeFuturePEMultipleCalculator';
import { SmallCapFuturePEMultipleCalculator } from './SmallCapFuturePEMultipleCalculator';
import { SponsoredFuturePEMultipleCalculator } from './SponsoredFuturePEMultipleCalculator';
import type { FuturePEMultipleStrategy } from './FuturePEMultipleContext';
import { hasOnlyFairValue } from './validation';
import { CreateNarrativeFuturePEMultipleCalculator } from './CreateNarrativeFuturePEMultipleCalculator';
import type { NarrativeValuatorCompany } from '../../hooks/narrativeValuatorCompanyFragment';

export class FuturePEMultipleCalculatorFactory {
  static createCalculator(
    valuation: Valuation | null | undefined,
    company: NarrativeValuatorCompany,
    hasHadSponsorship: boolean
  ): FuturePEMultipleStrategy {
    if (!valuation || hasOnlyFairValue(valuation)) {
      return new CreateNarrativeFuturePEMultipleCalculator(company);
    }

    if (hasHadSponsorship) {
      return new SponsoredFuturePEMultipleCalculator(valuation);
    }

    if ((company.analysisValue?.marketCapUSD ?? Infinity) < 1000000000) {
      // Less than 1B market cap
      return new SmallCapFuturePEMultipleCalculator(valuation);
    }

    return new ViewEditNarrativeFuturePEMultipleCalculator(valuation);
  }
}
